// import React from "react";
// import { motion } from "framer-motion";
// import { Link } from "react-router-dom";
// import logo from "../images/logo.png";

// const Footer = () => {
//   const fadeUp = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { opacity: 1, y: 0 },
//   };

//   const container = {
//     hidden: { opacity: 0 },
//     visible: { opacity: 1, transition: { staggerChildren: 0.15 } },
//   };

//   const currentYear = new Date().getFullYear();

//   const linkStyle = {
//     color: "#555555",
//     textDecoration: "none",
//     fontFamily: "'Poppins', sans-serif",
//     fontSize: "1rem",
//     display: "flex",
//     alignItems: "center",
//     gap: "8px",
//     transition: "color 0.2s",
//   };

//   const handleMouseEnter = (e) => {
//     e.currentTarget.style.color = "#967d6c";
//   };
//   const handleMouseLeave = (e) => {
//     e.currentTarget.style.color = "#555555";
//   };

//   const legalLinkStyle = {
//     color: "#999999",
//     textDecoration: "none",
//     fontFamily: "'Poppins', sans-serif",
//     fontSize: "0.8rem",
//     transition: "color 0.2s",
//   };

//   const handleLegalMouseEnter = (e) => {
//     e.currentTarget.style.color = "#967d6c";
//   };
//   const handleLegalMouseLeave = (e) => {
//     e.currentTarget.style.color = "#999999";
//   };

//   return (
//     <motion.footer
//       initial="hidden"
//       whileInView="visible"
//       viewport={{ once: true }}
//       variants={container}
//       style={{ background: "#f4ede7", width: "100%" }}
//     >
//       {/* MAIN FOOTER CONTENT */}
//       <div
//         style={{
//           maxWidth: "1200px",
//           margin: "0 auto",
//           padding: "64px 24px 40px",
//         }}
//       >
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
//             gap: "40px",
//           }}
//         >
//           {/* LOGO + TAGLINE */}
//           <motion.div
//             variants={fadeUp}
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "flex-start",
//             }}
//           >
//             <Link to="/">
//               <img
//                 src={logo}
//                 alt="Furbabies.AI Logo"
//                 style={{
//                   height: "120px",
//                   objectFit: "contain",
//                   marginBottom: "16px",
//                 }}
//               />
//             </Link>
//             <p
//               style={{
//                 fontFamily: "'Poppins', sans-serif",
//                 color: "#777777",
//                 fontSize: "0.9rem",
//                 lineHeight: "1.7",
//                 maxWidth: "220px",
//               }}
//             >
//               AI-powered pet health and nutrition for pet lovers who treat their
//               furbabies like family.
//             </p>

//             {/* ADDRESS */}
//             <div
//               style={{
//                 marginTop: "16px",
//                 display: "flex",
//                 alignItems: "flex-start",
//                 gap: "8px",
//               }}
//             >
//               <i
//                 className="fa fa-map-marker"
//                 style={{
//                   color: "#bda697",
//                   fontSize: "0.85rem",
//                   marginTop: "3px",
//                 }}
//               ></i>
//               <address
//                 style={{
//                   fontFamily: "'Poppins', sans-serif",
//                   color: "#999999",
//                   fontSize: "0.82rem",
//                   lineHeight: "1.7",
//                   fontStyle: "normal",
//                 }}
//               >
//                 495 Grand Blvd, #206
//                 <br />
//                 Miramar Beach, FL 32550
//                 <br />
//                 US
//               </address>
//             </div>
//           </motion.div>

//           {/* QUICK LINKS */}
//           <motion.div
//             variants={fadeUp}
//             style={{ display: "flex", flexDirection: "column" }}
//           >
//             <h3
//               style={{
//                 fontFamily: "'Poltawski Nowy', serif",
//                 fontWeight: "bold",
//                 fontSize: "1.1rem",
//                 color: "#222222",
//                 marginBottom: "20px",
//               }}
//             >
//               Quick Links
//             </h3>
//             <ul
//               style={{
//                 listStyle: "none",
//                 padding: 0,
//                 margin: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "12px",
//               }}
//             >
//               {[
//                 { name: "Home", path: "/" },
//                 { name: "About Us", path: "/about" },
//                 { name: "Contact Us", path: "/contact" },
//                 { name: "Sign Up Free", path: "/signup" },
//                 { name: "Login", path: "/login" },
//               ].map((link, index) => (
//                 <li key={index}>
//                   <Link
//                     to={link.path}
//                     style={linkStyle}
//                     onMouseEnter={handleMouseEnter}
//                     onMouseLeave={handleMouseLeave}
//                   >
//                     {link.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </motion.div>

//           {/* RESOURCES */}
//           <motion.div
//             variants={fadeUp}
//             style={{ display: "flex", flexDirection: "column" }}
//           >
//             <h3
//               style={{
//                 fontFamily: "'Poltawski Nowy', serif",
//                 fontWeight: "bold",
//                 fontSize: "1.1rem",
//                 color: "#222222",
//                 marginBottom: "20px",
//               }}
//             >
//               Resources
//             </h3>
//             <ul
//               style={{
//                 listStyle: "none",
//                 padding: 0,
//                 margin: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "12px",
//               }}
//             >
//               {[
//                 { name: "Furblog", path: "/blog" },
//                 { name: "Newsletter", path: "/newsletter" },
//               ].map((link, index) => (
//                 <li key={index}>
//                   <Link
//                     to={link.path}
//                     style={linkStyle}
//                     onMouseEnter={handleMouseEnter}
//                     onMouseLeave={handleMouseLeave}
//                   >
//                     {link.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </motion.div>

//           {/* SOCIAL MEDIA */}
//           <motion.div
//             variants={fadeUp}
//             style={{ display: "flex", flexDirection: "column" }}
//           >
//             <h3
//               style={{
//                 fontFamily: "'Poltawski Nowy', serif",
//                 fontWeight: "bold",
//                 fontSize: "1.1rem",
//                 color: "#222222",
//                 marginBottom: "20px",
//               }}
//             >
//               Follow Us
//             </h3>
//             <ul
//               style={{
//                 listStyle: "none",
//                 padding: 0,
//                 margin: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "12px",
//               }}
//             >
//               {[
//                 {
//                   name: "Facebook",
//                   path: "https://www.facebook.com/profile.php?id=61583366162393",
//                   icon: "fa-facebook",
//                 },
//                 {
//                   name: "Instagram",
//                   path: "https://www.instagram.com/furbabiesapp/",
//                   icon: "fa-instagram",
//                 },
//                 {
//                   name: "TikTok",
//                   path: "https://www.tiktok.com/@furbabiesapp",
//                   icon: "fa-music",
//                 },
//                 {
//                   name: "LinkedIn",
//                   path: "https://www.linkedin.com/company/furbabies-ai",
//                   icon: "fa-linkedin",
//                 },
//                 {
//                   name: "X (Twitter)",
//                   path: "https://x.com/furbabiesapp",
//                   icon: "fa-twitter",
//                 },
//               ].map((platform, index) => (
//                 <li key={index}>
//                   <a
//                     href={platform.path}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     style={linkStyle}
//                     onMouseEnter={handleMouseEnter}
//                     onMouseLeave={handleMouseLeave}
//                   >
//                     <i
//                       className={`fa ${platform.icon}`}
//                       style={{
//                         color: "#bda697",
//                         fontSize: "1rem",
//                         width: "16px",
//                       }}
//                     ></i>
//                     {platform.name}
//                   </a>
//                 </li>
//               ))}
//             </ul>
//           </motion.div>
//         </div>
//       </div>

//       {/* DIVIDER */}
//       <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 24px" }}>
//         <div style={{ borderTop: "1px solid #e0d5ce" }}></div>
//       </div>

//       {/* BOTTOM BAR */}
//       <div
//         style={{ maxWidth: "1200px", margin: "0 auto", padding: "20px 24px" }}
//       >
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "row",
//             justifyContent: "space-between",
//             alignItems: "center",
//             flexWrap: "wrap",
//             gap: "12px",
//           }}
//         >
//           {/* Copyright */}
//           <p
//             style={{
//               fontFamily: "'Poppins', sans-serif",
//               color: "#999999",
//               fontSize: "0.85rem",
//               margin: 0,
//             }}
//           >
//             © {currentYear} Furbabies.AI — All rights reserved.
//           </p>

//           {/* Legal links */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             {[
//               { name: "Terms & Conditions", path: "/terms" },
//               { name: "Privacy Policy", path: "/privacy-policy" },
//               { name: "Cookie Policy", path: "/cookie-policy" },
//             ].map((item, i) => (
//               <React.Fragment key={item.path}>
//                 <Link
//                   to={item.path}
//                   style={legalLinkStyle}
//                   onMouseEnter={handleLegalMouseEnter}
//                   onMouseLeave={handleLegalMouseLeave}
//                 >
//                   {item.name}
//                 </Link>
//                 {i < 2 && (
//                   <span style={{ color: "#e0d5ce", fontSize: "0.75rem" }}>
//                     |
//                   </span>
//                 )}
//               </React.Fragment>
//             ))}
//           </div>

//           {/* Made with love */}
//           <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//             <i
//               className="fa fa-paw"
//               style={{ color: "#bda697", fontSize: "0.85rem" }}
//             ></i>
//             <p
//               style={{
//                 fontFamily: "'Poppins', sans-serif",
//                 color: "#999999",
//                 fontSize: "0.85rem",
//                 margin: 0,
//               }}
//             >
//               Made with love for pet lovers everywhere
//             </p>
//             <i
//               className="fa fa-paw"
//               style={{ color: "#bda697", fontSize: "0.85rem" }}
//             ></i>
//           </div>
//         </div>
//       </div>
//     </motion.footer>
//   );
// };

// export default Footer;
import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import logo from "../images/logo.png";

const Footer = () => {
  const fadeUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const container = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.15 } },
  };

  const currentYear = new Date().getFullYear();

  const linkStyle = {
    color: '#555555',
    textDecoration: 'none',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'color 0.2s',
  };

  const handleMouseEnter = (e) => { e.currentTarget.style.color = '#967d6c'; };
  const handleMouseLeave = (e) => { e.currentTarget.style.color = '#555555'; };

  const legalLinkStyle = {
    color: '#999999',
    textDecoration: 'none',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '0.8rem',
    transition: 'color 0.2s',
  };

  const handleLegalMouseEnter = (e) => { e.currentTarget.style.color = '#967d6c'; };
  const handleLegalMouseLeave = (e) => { e.currentTarget.style.color = '#999999'; };

  return (
    <motion.footer
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={container}
      style={{ background: '#f4ede7', width: '100%' }}
    >
      {/* MAIN FOOTER CONTENT */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '64px 24px 40px' }}>

        {/* Responsive grid: fixed logo col on desktop, stacked on mobile */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: '40px',
          alignItems: 'start',
        }}>

          {/* LOGO + TAGLINE + ADDRESS */}
          <motion.div
            variants={fadeUp}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              maxWidth: '220px',
            }}
          >
            <Link to="/">
              <img
                src={logo}
                alt="Furbabies.AI Logo"
                style={{ height: '110px', objectFit: 'contain', marginBottom: '16px' }}
              />
            </Link>
            <p style={{
              fontFamily: "'Poppins', sans-serif",
              color: '#777777',
              fontSize: '0.88rem',
              lineHeight: '1.7',
              margin: '0 0 16px 0',
            }}>
              AI-powered pet health and nutrition for pet lovers who treat their furbabies like family.
            </p>

            {/* ADDRESS */}
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
              <i
                className="fa fa-map-marker"
                style={{ color: '#bda697', fontSize: '0.85rem', marginTop: '4px', flexShrink: 0 }}
              ></i>
              <address style={{
                fontFamily: "'Poppins', sans-serif",
                color: '#999999',
                fontSize: '0.82rem',
                lineHeight: '1.7',
                fontStyle: 'normal',
                margin: 0,
              }}>
                495 Grand Blvd, #206<br />
                Miramar Beach, FL 32550<br />
                US
              </address>
            </div>
          </motion.div>

          {/* QUICK LINKS */}
          <motion.div variants={fadeUp} style={{ display: 'flex', flexDirection: 'column' }}>
            <h3 style={{
              fontFamily: "'Poltawski Nowy', serif",
              fontWeight: 'bold',
              fontSize: '1.1rem',
              color: '#222222',
              marginBottom: '20px',
              marginTop: 0,
            }}>
              Quick Links
            </h3>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
            }}>
              {[
                { name: 'Home', path: '/' },
                { name: 'About Us', path: '/about' },
                { name: 'Contact Us', path: '/contact' },
                { name: 'Sign Up Free', path: '/signup' },
                { name: 'Login', path: '/login' },
              ].map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    style={linkStyle}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* RESOURCES */}
          <motion.div variants={fadeUp} style={{ display: 'flex', flexDirection: 'column' }}>
            <h3 style={{
              fontFamily: "'Poltawski Nowy', serif",
              fontWeight: 'bold',
              fontSize: '1.1rem',
              color: '#222222',
              marginBottom: '20px',
              marginTop: 0,
            }}>
              Resources
            </h3>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
            }}>
              {[
                { name: 'Furblog', path: '/blog' },
                { name: 'Newsletter', path: '/newsletter' },
              ].map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    style={linkStyle}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* SOCIAL MEDIA */}
          <motion.div variants={fadeUp} style={{ display: 'flex', flexDirection: 'column' }}>
            <h3 style={{
              fontFamily: "'Poltawski Nowy', serif",
              fontWeight: 'bold',
              fontSize: '1.1rem',
              color: '#222222',
              marginBottom: '20px',
              marginTop: 0,
            }}>
              Follow Us
            </h3>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
            }}>
              {[
                { name: 'Facebook',   path: 'https://www.facebook.com/profile.php?id=61583366162393', icon: 'fa-facebook' },
                { name: 'Instagram',  path: 'https://www.instagram.com/furbabiesapp/',                icon: 'fa-instagram' },
                { name: 'TikTok',     path: 'https://www.tiktok.com/@furbabiesapp',                   icon: 'fa-music' },
                { name: 'LinkedIn',   path: 'https://www.linkedin.com/company/furbabies-ai',           icon: 'fa-linkedin' },
                { name: 'X (Twitter)',path: 'https://x.com/furbabiesapp',                              icon: 'fa-twitter' },
              ].map((platform, index) => (
                <li key={index}>
                  <a
                    href={platform.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={linkStyle}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <i
                      className={`fa ${platform.icon}`}
                      style={{ color: '#bda697', fontSize: '1rem', width: '16px' }}
                    ></i>
                    {platform.name}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>

        </div>
      </div>

      {/* DIVIDER */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
        <div style={{ borderTop: '1px solid #e0d5ce' }}></div>
      </div>

      {/* BOTTOM BAR */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px 24px' }}>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '12px',
        }}>

          {/* Copyright */}
          <p style={{
            fontFamily: "'Poppins', sans-serif",
            color: '#999999',
            fontSize: '0.85rem',
            margin: 0,
          }}>
            © {currentYear} Furbabies.AI — All rights reserved.
          </p>

          {/* Legal links */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
            {[
              { name: 'Terms & Conditions', path: '/terms' },
              { name: 'Privacy Policy',     path: '/privacy-policy' },
              { name: 'Cookie Policy',      path: '/cookie-policy' },
            ].map((item, i) => (
              <React.Fragment key={item.path}>
                <Link
                  to={item.path}
                  style={legalLinkStyle}
                  onMouseEnter={handleLegalMouseEnter}
                  onMouseLeave={handleLegalMouseLeave}
                >
                  {item.name}
                </Link>
                {i < 2 && (
                  <span style={{ color: '#e0d5ce', fontSize: '0.75rem' }}>|</span>
                )}
              </React.Fragment>
            ))}
          </div>

          {/* Made with love */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <i className="fa fa-paw" style={{ color: '#bda697', fontSize: '0.85rem' }}></i>
            <p style={{
              fontFamily: "'Poppins', sans-serif",
              color: '#999999',
              fontSize: '0.85rem',
              margin: 0,
            }}>
              Made with love for pet lovers everywhere
            </p>
            <i className="fa fa-paw" style={{ color: '#bda697', fontSize: '0.85rem' }}></i>
          </div>

        </div>
      </div>

    </motion.footer>
  );
};

export default Footer;